export default __webpack_public_path__ + "static/char-s-42-zh-Hans-fe440a2134e9de08499cbaf8d5c5a312.png";